import { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoHomePage from '../../Assets/Images/logo-phl-homepage-update.svg.png';
import { CustomSideBar } from '../custom-sidebar/CustomSideBar';
import CustomerAccountInfomation from '../../Pages/cus/cus-account-info';
import CustomerPolicy from '../../Pages/cus/cus-policy';
import PaymentRequest from '../../Pages/payment/payment-request';
import ClaimRequest from '../../Pages/claim/claim-request';
import PosRequest from '../../Pages/pos/pos-request';
import CustomerChangePassword from '../../Pages/cus/cus-change-password';
import { t } from 'i18next';
import * as Service from '../../Services/service';
import * as CustomerService from '../../Services/customer-service';

export const CustomNav = ({ objectDto, setObjectDto, width, height }) => {
  const navigation = useNavigate();
  const location = useLocation(); // <-- NEW
  const sideBarRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Define menu items
  const menuItems = [
    { title: t("customerinfo"), icon: <i className="fa fa-folder" />, route: "/khach-hang" },
    { title: t("policycustomer"), icon: <i className="fa fa-file-text" />, route: "/danh-sach-hop-dong" },
    { title: t("onlinepaymentcustomer"), icon: <i className="fa fa-credit-card-alt" />, external: process.env.REACT_APP_PAYMENT_URL },
    { title: t("settlementofinsurancebenefitcustomer"), icon: <i className="fa fa-database" />, external: process.env.REACT_APP_CLAIM_URL },
    { title: t("posrequestcustomer"), icon: <i className="fa fa-info-circle" />, external: process.env.REACT_APP_POS_URL },
    { title: t("changepassword"), icon: <i className="fa fa-key" />, route: "/doi-mk" },
    { title: t("logout"), icon: <i className="fa fa-arrow-circle-left" />, action: () => { CustomerService.LogOut(setObjectDto); navigation("/"); } }
  ];

  const handleMenuItemClick = (item) => {
    if (item.route) {
      navigation(item.route);
    } else if (item.external) {
      Service.openInNewTab(item.external);
    } else if (item.action) {
      item.action();
    }
    setIsSidebarOpen(false);
    sessionStorage.removeItem('objectDto');
  };

  // Determine active item based on current route
  const getActiveItem = (item) => {
    if (item.route && location.pathname === item.route) return true;
    return false;
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  if (!objectDto) return null;

  return (
    width <= 768 ?
    <div className={`app ${isSidebarOpen ? 'sidebar-open' : 'sidebar-close'}`} style={{ height: "100%" }}>
      <CustomSideBar isOpen={isSidebarOpen} sideBarRef={sideBarRef} setIsOpen={setIsSidebarOpen} onClose={toggleSidebar} />
      <div ref={sideBarRef} className="content-nav" style={{ height }}>
        <div className='nav-header'>
            <div className="image-block">
                <div className="image-style-cus-info" style={{ backgroundImage: `url(${LogoHomePage})` }} />
            </div>
            <p className="welcome-customer-info description-small-customer" style={{ padding: "0", textAlign: "center", margin: "0" }}>
                {t("welcometitle")}
            </p>
            <p className="fullname-customer-info header-span-customer" style={{ textAlign: "center", paddingBottom: "5%" }}>{objectDto.fullName || ''}</p>
            <nav className={"menu-nav"} style={{ marginTop: "-20px" }}>
                <ul>
                    {menuItems.map((item, index) => (
                        <li
                        key={index}
                        className='menu-item'
                        onClick={() => handleMenuItemClick(item)}
                        style={{ backgroundColor: getActiveItem(item) ? "black" : "" }}
                        >
                            <span className='span-nav-items  description-small-customer' style={{ color: getActiveItem(item) ? "white" : "" }}>{item.icon}</span>
                            <span className={item.title === t("onlinepaymentcustomer") ?
                                'span-nav-items title-nav-smaller description-small-customer' :
                                'span-nav-items title-nav  description-small-customer'}
                                 style={{ color: getActiveItem(item) ? "white" : "" }}>{item.title}</span>
                            <span className='glyphicon glyphicon-play span-nav-items  description-small-customer' style={{ color: getActiveItem(item) ? "white" : "", float: 'right' }}></span>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="span-hotline-customer-info description-large-customer">
                <p style={{ textAlign: "center", margin: 0 }}>Hotline: <span style={{ fontWeight: "bold" }}>1900 886 838</span></p>
            </div>
        </div>
      </div>
    </div>
    :
    <div className='nav-header'>
      <div className="image-block">
        <div className="image-style-cus-info" style={{ backgroundImage: `url(${LogoHomePage})` }} />
      </div>
      <p className="welcome-customer-info description-small-customer" style={{ textAlign: "center", margin: 0 }}>
        {t("welcometitle")}
      </p>
      <p className="fullname-customer-info header-span-customer" style={{ textAlign: "center", paddingBottom: "5%" }}>
        {objectDto.fullName || ''}
      </p>
      <nav className="menu-nav">
        <ul>
          {menuItems.map((item, index) => (
            <li
              key={index}
              className='menu-item'
              onClick={() => handleMenuItemClick(item)}
              style={{ backgroundColor: getActiveItem(item) ? "black" : "" }}
            >
              <span className='span-nav-items description-small-customer' style={{ color: getActiveItem(item) ? "white" : "" }}>
                {item.icon}
              </span>
              <span className='span-nav-items title-nav description-small-customer' style={{ color: getActiveItem(item) ? "white" : "" }}>
                {item.title}
              </span>
              <span className='glyphicon glyphicon-play span-nav-items description-small-customer' style={{ color: getActiveItem(item) ? "white" : "", float: 'right' }}></span>
            </li>
          ))}
        </ul>
      </nav>
      <div className="span-hotline-customer-info description-large-customer">
        <p style={{ textAlign: "center", margin: 0 }}>Hotline: <span style={{ fontWeight: "bold" }}>1900 886 838</span></p>
      </div>
    </div>
  );
};

export default CustomNav;
